var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.901042 8.01172C3.33619 7.14209 5.99715 7.14209 8.43229 8.01172C8.97243 8.20463 9.3333 8.71617 9.33333 9.28971V10.1667C9.33333 10.9583 8.63198 11.5664 7.84831 11.4544L7.21224 11.3639C5.52375 11.1227 3.80958 11.1227 2.12109 11.3639L1.48503 11.4544C0.701357 11.5664 0 10.9583 0 10.1667V9.28971C2.85423e-05 8.71617 0.360905 8.20463 0.901042 8.01172Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 0C6.13943 0 7.33333 1.19391 7.33333 2.66667C7.33333 4.13943 6.13943 5.33333 4.66667 5.33333C3.19391 5.33333 2 4.13943 2 2.66667C2 1.19391 3.19391 0 4.66667 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.aaf93fd5b9d9256fa71b6edae574cf6d.svg";
export { ForwardRef as ReactComponent };